import React from "react";
import { DiagnosticItem } from "Components/overview";
import { Box } from "@mui/material";

const DiagnosticsList = ({ diagnosticsPickers, dataIsRecent }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 320px))",
      columnGap: 1,
      rowGap: 0,
    }}
  >
    {diagnosticsPickers &&
      diagnosticsPickers.map((item) => (
        <DiagnosticItem
          key={`${item.displayName}_diagnostic`}
          displayName={item.displayName}
          value={item.value}
          unit={item.unit}
          category={item.category}
          isAlarmActive={item.isActive}
          dataIsRecent={dataIsRecent}
        />
      ))}
  </Box>
);



export default DiagnosticsList;
